export enum CancerTherapyType {
  Unknown = -1,
  Other,
  Immunobody,
  Antibody,
  Radiation,
  Hormone,
  Chemo,
  Surgery,
}